import styled from "styled-components";
import {
  activity_tracker_keys,
  customerOfferKeys_mapping,
  document_request_mapping,
  frontend_docs_key_mapping,
  Frontend_msg_for_document,
  mapping_sheet,
  pending_status_code,
  pending_with_keys,
  mapping_appointment_details
} from "./mapping_sheet";

export const Wrapper = styled.section`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: black;
  object-fit: contain;
  margin-bottom: 40px;
  font-family: Arial;
`;

export const InputWrapper = styled.div`
  width: 90%;
  height: auto;
  margin: 19px 0 10px;
  border-radius: 5px;
  border: solid 1px ${(props) => (props.error ? "red" : "black")};
  @media (max-width: 767px) {
    width: 100%;
    margin: 19px 0 20px;
  }
`;

export const DatePickerCom = styled.div`
  width: 80%;
  height: auto;
  margin: 19px 10px 0px 0px;
  border-radius: 5px;
  border: solid 1px ${(props) => (props.error ? "red" : "black")};
  @media (max-width: 767px) {
    width: 50%;
    margin: 10px 10px 0px 0px;
  }
`;

export const getURlParameter = (param) => {
  let sPageURl = window.location.search.substring(1);
  let sURLVriable = sPageURl.split("&");
  for (var i = 0; i < sURLVriable.length; i++) {
    let sParameterName = sURLVriable[i].split("=");
    if (sParameterName[0] == param) return sParameterName[1];
  }
};

export const CenterDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SearchButton = styled.div`
  width: 157px;
  height: 50px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "linear-gradient(to top, #ff4f005c, #f5851f66)" : "linear-gradient(to top, #f26221, #f5851f)"};
  @media (max-width: 767px) {
    margin: 26px 22px 30px 0;
    border-radius: 17.5px;
  }
  .ant-btn-text {
    color: white !important;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
    }
  }
`;

export const statusPage = {
  expired: "Expired",
  cancelled: "Cancelled",
  pending: "Pending",
  enforced: "Enforced",
  Terminated: "Terminated",
  lapsed: "lapsed",
  Rejected: "Rejected",
  PendingRenewal: "PENDINGRENEWAL",
  RENEWALPENDING: "RENEWALPENDING",
};

export const error_message = {
  common_error:
    "We are facing some issue at the moment, please try after some time.",
  pancard_error: "Please Enter Mandatory Pancard Number / In Correct Format",
  policy_input_error: "Please Enter Valid Policy Number",
  date_input_error: "Please Enter Valid Date Of Birth",
  tnc_error: "Please check the terms and conditions",
  download_error: "Please select valid date range",
  good_health_error: "Please check Good Health Checkbox",
};

export const numeric_validation_regx = /^\d+$/;

export const kyc_document = {
  photo: [{ label: "Passport Size Photograph", value: "PHOTO" }],
  IDENTITYPROOF: [
    { label: "Pan Card", value: "PANCARD" },
    { label: "Passport", value: "PASSPORT" },
    { label: "Voter ID card", value: "VOTEID" },
    { label: "Driving license", value: "DLICESSE" },
    {
      label: "Job Card issued by NREGA duly signed by Govt. Officer",
      value: "JOBCARD",
    },
    {
      label: "Letter issued by National Population Register",
      value: "LETTERHEAD",
    },
    { label: "Aadhar Card", value: "AADHARCARD" },
    {
      label:
        "Letter from Gazetted Officer with duly attested photograph of customer",
      value: "GAZETTEOFFICER",
    },
  ],
  KYCADDRESSPROOF: [
    { value: "PROPERTYTAX", label: "Property or Municipal tax receipt" },
    { value: "PASSPORT", label: "Passport" },
    { value: "VOTEID", label: "Voter ID card" },
    { value: "DLICESSE", label: "Driving license" },
    { value: "AADHARCARD", label: "Aadhar Card" },
    {
      value: "UTILITYBILL",
      label:
        "Utility Bills (Electricity, Piped Gas, Water Bill - not older than 2 months)",
    },
    {
      value: "ACCOMODATIONLETTER",
      label: "Accomodation allotment letter from Govt. Dept",
    },
    { value: "BANKPASSBOOK", label: "Bank Passbook/Statement" },
    {
      value: "PHONEBILL",
      label:
        "Recent Telephone Bill / Postpaid Mobile Bill (not older than 2 months)",
    },
  ],
};

export const status_code_constant_data = {
  Add_info: ["Add Info", "ADD_INFO", "ADDINFO", "ADDINO"],
  PPMC: "PPMC",
  SpecialCondition: ["Sp Cond", " Sp Conditions", "Spl Cond", "SpConditions"],
  Loading: "Loading",
  CounterOffer: "CounterOffer",
  CoPayment: "Co payment",
  Deductible: "Deductible",
  TeleUW: "TeleUW",
};

export const showMedicalUploadBtn = ({ status, type }) => {
  let isAdd_info_present = false
  if (Array.isArray(type)) {
    type.forEach((ei) => {
      if (status.includes(ei) && status.toLowerCase().includes("pending")) {
        isAdd_info_present = status.includes(ei)
      }
    })
  }
  return isAdd_info_present
}

export const currentStatus_Key = (status, type) => {
  if (!status) return null;
  const arr = mapping_sheet;

  const finalObj = arr.find((obj) => `${obj.SysCode}` == `${status}`);
  if (finalObj == undefined) return status;
  if (status.includes("+") && type) {
    const dummyArray1 = status.split("+");
    if (parseInt(shareIndexOf(dummyArray1, type)) >= 0) {
      const dummyArray = finalObj.msg.split("+");
      return dummyArray[parseInt(shareIndexOf(dummyArray1, type))];
    }
  }

  if (finalObj.msg.includes("+") && type && whetherItConainsEle(status, type)) {
    return manageComplexCode(finalObj.msg.split("+"), type);
  }

  if (finalObj.msg.includes("+")) {
    const msg = removeDuplicateEle(finalObj.msg.split("+"));
    return msg.join(",");
  }
  return finalObj.msg;
};

const whetherItConainsEle = (status, type) => {
  if (Array.isArray(type)) {
    const res = type.find((ei) => status.includes(ei));
    return !!res;
  }
  return status.includes(type) ? true : false;
};

const removeDuplicateEle = (arr) => {
  const newArr = [];
  for (const ele of arr) {
    if (!newArr.includes(ele.trim())) newArr.push(ele);
  }
  return newArr;
};

const manageComplexCode = (data, type) => {
  let type_data = type;
  const { PPMC, CounterOffer } = status_code_constant_data;

  if (Array.isArray(type)) {
    if (type.includes("SpConditions")) {
      type_data = "Special Condition";
    }
    if (type.includes("ADD_INFO")) {
      type_data = "Add Info";
    }
  }

  switch (type) {
    case CounterOffer:
      type_data = "Counter offer";
      break;
    case PPMC:
      type_data = "PPMC";
      break;
  }
  let ele_val = "";

  data.forEach((ele, i) => {
    if (ele.toLowerCase().includes(type_data.toLowerCase())) {
      ele_val = ele;
    }
  });
  return ele_val;
};

const shareIndexOf = (arr, type) => {
  let index = -1;

  if (Array.isArray(type)) {
    for (let i = 0; i <= type.length - 1; i++) {
      for (let j = 0; j <= arr.length - 1; j++) {
        if (arr[j].includes(type[i])) {
          index = j;
        }
      }
    }
  }

  arr.forEach((ele, i) => {
    if (ele.includes(type)) {
      index = i;
    }
  });
  return index;
};

export const pendingStatus_Key = (obj1) => {
  if (!obj1.ReceivedStatusCd) return obj1;
  const arr = pending_status_code;

  const finalObj = arr.find((obj) => {
    const { Document, DocumentType, Frontend_msg, ReceivedStatusCd } = obj;
    return (
      `${obj1.DocumentCd}` == `${DocumentType}` &&
      `${obj1.DocCategoryCd}` == `${Document}` &&
      `${obj1.ReceivedStatusCd}` == `${ReceivedStatusCd}`
    );
  });

  const dummyObj = {
    Frontend_msg: obj1?.ReceivedStatusCd,
    ReceivedStatusCd: obj1?.ReceivedStatusCd,
  };
  if (finalObj == undefined) return dummyObj;
  return finalObj;
};

export const uploadStatus_Key = (type, subtype) => {
  const arr = document_request_mapping;

  const finalObj = arr.find((obj) => {
    const { Document, DocumentType } = obj;
    return `${type}` == `${Document}` && `${subtype}` == `${DocumentType}`;
  });

  return finalObj;
};

export const activityTracker_key = (type) => {
  const arr = activity_tracker_keys;
  const finalObj = arr.find((obj) => {
    const { ActivityTracker_key } = obj;
    return `${type}` == `${ActivityTracker_key}`;
  });
  if (finalObj == undefined) return type;
  return finalObj.ActicityTracker_value;
};

export const pendingWith_key = (key, type) => {
  const arr = pending_with_keys;
  const finalObj = arr?.find((obj) => {
    return `${key}` == `${obj.status_code}`;
  });
  if (finalObj == undefined) return null;

  return finalObj?.pending_with;
};

export const counterWith_key = (key) => {
  const arr = customerOfferKeys_mapping;
  const finalObj = arr.find((obj) => {
    return `${key}` == `${obj.status_code}`;
  });
  if (finalObj == undefined) return null;
  return finalObj.pending_with;
};

export const DocumentType_key = (key) => {
  const arr = frontend_docs_key_mapping;
  const finalObj = arr.find((obj) => {
    return `${key}` == `${obj.key_Doctype}`;
  });
  if (finalObj == undefined) return key;
  return finalObj.msg;
};

export const Document_key = (key) => {
  const arr = Frontend_msg_for_document;
  const finalObj = arr.find((obj) => {
    return `${key}` == `${obj.key_Doctype}`;
  });
  if (finalObj == undefined) return key;
  return finalObj.msg;
};

export const getAppointmentWiseStatus = (status) => {
  const arr = mapping_appointment_details;
  const finalObj = arr.find((obj) => `${obj.SysCode}` === `${status}`);
  return finalObj;
}